module.exports = __webpack_public_path__ + "img/welcome-back-288b375d8e0a9ec35b002530383a5f1d.png";